export const ar = {
  pay: 'الدفع',
  requestStatus: 'حالة الطلب',
  successMessage: 'تم إرسال الإخطار  بنجاح',
  successMessageDescription: 'تم الدفع بنجاح و تقديم طلبك رقم {requestNumber}',
  failed: 'تعذر إرسال الإخطار',
  failedMessage: 'عملية الدفع غير مكتملة، الرجاء التحقق من عملية الدفع لاستكمال الاشعار',
  failedMessageContactSupport: 'أو مراجعة الدعم الفني بالكود التالي',
  cancelled: 'بإنتظار الدفع',
  cancelledMessage: 'لم تتم عملية الدفع حتى الآن، يمكنك إعادة المحاولة مرة أخرى',
  retrycheckout: 'إعادة المحاولة',

  awaitingPaymentMessage: 'تم إنشاء فاتورة سداد بنجاح وحالة طلبك الآن بإنتظار السداد',
  awaitingPayment: 'بإنتظار السداد',
  sadadBillExpired: 'انتهاء صلاحية فاتورة سداد',
  sadadBillExpiredMessage: 'تم إلغاء رقم الفاتورة لإنتهاء فترة السداد',
  sadadReferenceNumber: 'رقم فاتورة سداد',
  shouldPaidBefore: 'يجب ان يتم الدفع قبل ',
  copiedSuccessfully: 'تم النسخ بنجاح',
  backToTechSupport: 'مراجعة الدعم الفني',
  backToHome: 'العودة للرئيسية',
  requestsList: 'قائمة الطلبات',
  paymentInfo: 'بيانات الدفع',
  requestPreview: 'معاينة الطلب',
  referenceNumber: 'الرقم المرجعي',
  paymentStatus: 'حالة الدفع',
  paymentCompletedSuccessfully: 'تم الدفع بنجاح',
  underProcessingMessage: 'سيتم تقديم الطلب مباشرة بعد التأكيد',
  underProcessing: 'بإنتظار بوابة الدفع لتأكيد العملية',
};
